<template>
  <div class="parent-consent-wrap">
    <main class="screen" role="main">

      <div class="header">
        <button
          type="button"
          class="back-button"
          aria-label="Zurück"
          @click="$router.push('/consent/age')"
        >←</button>
      </div>

      <div class="intro">
        <p class="intro-eyebrow">Quiz für Ihr Kind</p>
        <h1 class="intro-title">Elterliches Einverständnis</h1>
        <p class="intro-text">
          Da Ihr Kind unter 15 Jahre alt ist, geben Sie als Elternteil oder
          Erziehungsberechtigte/r das Einverständnis.
        </p>
      </div>

      <ul class="info-list">
        <li>
          <span class="info-icon" aria-hidden="true">✓</span>
          <span>Die Antworten werden anonym gespeichert.</span>
        </li>
        <li>
          <span class="info-icon" aria-hidden="true">✓</span>
          <span>Eine E-Mail-Adresse fragen wir erst am Ende und nur freiwillig.</span>
        </li>
        <li>
          <span class="info-icon" aria-hidden="true">✓</span>
          <span>Die Daten werden zu Forschungszwecken an der BFH ausgewertet.</span>
        </li>
        <li>
          <span class="info-icon" aria-hidden="true">✓</span>
          <span>Sie können den Quiz jederzeit abbrechen.</span>
        </li>
      </ul>

      <label class="consent-checkbox" for="consent-parent">
        <input type="checkbox" id="consent-parent" v-model="consentParent">
        <span class="consent-text">
          Ich bin der Elternteil oder die erziehungsberechtigte Person und
          gebe mein Einverständnis, dass mein Kind am Swiss Eating Quiz
          teilnimmt.
        </span>
      </label>

      <label class="consent-checkbox" for="consent-data">
        <input type="checkbox" id="consent-data" v-model="consentData">
        <span class="consent-text">
          Ich bin einverstanden, dass die anonymen Antworten zu Forschungszwecken
          an der BFH ausgewertet werden.
        </span>
      </label>

      <div class="footer">
        <button
          type="button"
          class="next-button"
          :disabled="!canStart"
          @click="startQuiz"
        >Quiz starten</button>
      </div>

    </main>
  </div>
</template>

<script>
export default {
  name: 'ChildParentalConsent',
  data() {
    return {
      consentParent: false,
      consentData: false,
    };
  },
  computed: {
    canStart() {
      return this.consentParent && this.consentData;
    },
  },
  methods: {
    startQuiz() {
      if (this.canStart) this.$router.push('/quiz/vanilla/a');
    },
  },
};
</script>

<style scoped>
.parent-consent-wrap {
  --color-bg-page: #f5f4ef;
  --color-bg-card: #ffffff;
  --color-bg-muted: #f1efe8;
  --color-text-primary: #2c2c2a;
  --color-text-secondary: #5f5e5a;
  --color-text-tertiary: #888780;
  --color-border: rgba(0, 0, 0, 0.15);
  --color-accent: #534AB7;
  --color-accent-light: #EEEDFE;
  --radius-md: 8px;
  --radius-lg: 12px;
  --font-sans: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;

  background: var(--color-bg-page);
  font-family: var(--font-sans);
  color: var(--color-text-primary);
  line-height: 1.5;
  min-height: 100%;
  padding: 1.25rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  box-sizing: border-box;
}

.parent-consent-wrap *,
.parent-consent-wrap *::before,
.parent-consent-wrap *::after {
  box-sizing: border-box;
}

.screen {
  width: 100%;
  max-width: 420px;
  background: var(--color-bg-card);
  border-radius: var(--radius-lg);
  border: 0.5px solid var(--color-border);
  padding: 1.5rem 1.25rem;
  min-height: 600px;
  display: flex;
  flex-direction: column;
}

.header {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
}

.back-button {
  background: transparent;
  border: none;
  padding: 4px 8px;
  cursor: pointer;
  font-size: 20px;
  color: var(--color-text-secondary);
  line-height: 1;
}

.intro {
  margin-bottom: 1.5rem;
}

.intro-eyebrow {
  font-size: 13px;
  color: var(--color-text-secondary);
  margin: 0 0 8px;
}

.intro-title {
  font-size: 24px;
  font-weight: 500;
  margin: 0 0 12px;
  line-height: 1.25;
}

.intro-text {
  font-size: 15px;
  color: var(--color-text-secondary);
  margin: 0;
  line-height: 1.6;
}

.info-list {
  background: var(--color-bg-muted);
  border-radius: var(--radius-md);
  padding: 16px;
  margin: 0 0 1.5rem;
  list-style: none;
}

.info-list li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 14px;
  color: var(--color-text-secondary);
  line-height: 1.5;
  padding: 6px 0;
}

.info-icon {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--color-accent);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  margin-top: 1px;
}

.consent-checkbox {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  border: 0.5px solid var(--color-border);
  border-radius: var(--radius-md);
  cursor: pointer;
  background: var(--color-bg-card);
  margin-bottom: 12px;
  transition: background 0.15s, border-color 0.15s;
}

.consent-checkbox:hover {
  background: var(--color-bg-muted);
}

.consent-checkbox:has(input:checked) {
  border-color: var(--color-accent);
  background: var(--color-accent-light);
}

.consent-checkbox input[type="checkbox"] {
  margin: 2px 0 0 0;
  width: 18px;
  height: 18px;
  accent-color: var(--color-accent);
  flex-shrink: 0;
}

.consent-text {
  font-size: 14px;
  color: var(--color-text-primary);
  line-height: 1.5;
}

.footer {
  margin-top: auto;
  padding-top: 1rem;
}

.next-button {
  width: 100%;
  padding: 14px;
  background: var(--color-bg-muted);
  color: var(--color-text-tertiary);
  border: 0.5px solid var(--color-border);
  border-radius: var(--radius-md);
  font-size: 15px;
  font-family: inherit;
  cursor: not-allowed;
}

.next-button:not(:disabled) {
  background: var(--color-accent);
  color: white;
  border-color: var(--color-accent);
  cursor: pointer;
}

.next-button:not(:disabled):hover {
  opacity: 0.9;
}
</style>
